import * as React from "react";

/** `Date.now()`, re-read every `intervalMs` while something on screen is counting; null holds it
 *  still. For waits and countdowns that move between refetches on the page's own clock. */
export function useNow(intervalMs: number | null): number {
  const [now, setNow] = React.useState(() => Date.now());
  React.useEffect(() => {
    if (intervalMs === null) return;
    setNow(Date.now());
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);
  return now;
}
